/*
 * fn: formatComboResult
 *
 * Formats combo result strings
 *
 */
export const formatComboResult = (result: string) =>
  result.replace('Near-infinite', 'Significant').replaceAll('near-infinite', 'significant')
